import {Loader, Modal} from '@mantine/core';
import {useGetCommunityComment} from '../../../../core/repositories/communityRepository';
import {convertToLink} from '../../../../shared/services/convertToLink';
import {formatDateFullWithTime} from '../../../../shared/services/formatDate';

type Props = {
  opened: boolean;
  close: () => void;
  topicId: number;
  seqNumber: number;
  isSignedIn: boolean;
};

export const ReplyModal: React.FC<Props> = ({
  opened,
  close,
  topicId,
  seqNumber,
  isSignedIn,
}) => {
  const {data, isLoading} = useGetCommunityComment({
    topicId,
    seqNumber,
    config: {
      enabled: isSignedIn && seqNumber !== 0,
    },
  });

  if (seqNumber === 0) return null;

  return (
    <Modal
      opened={opened}
      onClose={close}
      size={668}
      padding={24}
      radius={12}
      centered={true}
      withCloseButton={false}
    >
      <div className="">
        {!isLoading && data?.ok ? (
          <>
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <p className="text-base text-black-2 font-bold leading mr-8">
                  {data.value.seqNumber}
                </p>
                <p
                  className={`${data.value.byAdmin ? 'text-notification-1' : 'text-black-2'} text-base font-bold leading`}
                >
                  {data.value.nickname}
                </p>
              </div>
              <p className="text-sm text-black-2 font-bold leading">
                {formatDateFullWithTime(data.value.createdAt)}
              </p>
            </div>
            <p className="text-base text-black-2 leading mt-8">
              {convertToLink(data.value.body)}
            </p>
          </>
        ) : (
          <div className="flex justify-center items-center h-52">
            <Loader color="gray" />
          </div>
        )}
      </div>
    </Modal>
  );
};
